import { HarvestTypes } from "@gtpl/shared-models/common-models"

export class RmCountReq{
    count:number
    type?:HarvestTypes

    constructor(count:number,type?:HarvestTypes){
        this.count = count
        this.type = type
    }
}